import { useState, useMemo } from "react";
import { Button, ModalDelete, Label } from "expano-components";
import useGet from "hooks/useGet";
import useDelete from "hooks/useDelete";

import { Main, PageLoader, Dashboard, Error } from "components";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

import AddPlatform from "./modals/AddPlatform";
import BasicData from "./components/BasicData";

const ShopEdit = ({
  match: {
    params: { id },
  },

  history,
}) => {
  const [show_delete_modal, setShowDeleteModal] = useState(false);
  const [show_add_platform_modal, setShowAddShopModal] = useState(false);
  const [channel_to_delete, setChannelToDelete] = useState({
    id: null,
    name: null,
  });

  const {
    is_loading,
    is_error,
    error,
    data: shop,
    refetch,
  } = useGet({
    query: ["shops", id],
    context: "ui_show",
    path: `/shops/${id}`,
  });

  const platform_ids = useMemo(() => {
    if (!shop?.channels?.length) {
      return [];
    }
    return shop.channels.map(({ platform }) => platform?.id);
  }, [shop?.channels]);

  const { _delete: deleteShop } = useDelete({ path: `/shops/${id}` });
  const { _delete: deleteChannel } = useDelete({
    path: `/channels/${channel_to_delete?.id}`,
  });

  const handleDelete = async () => {
    await deleteShop(id);
    setShowDeleteModal(false);
    history.push("/shops");
  };

  const handleDeleteChannel = async () => {
    await deleteChannel();
    setChannelToDelete(null);
    refetch();
  };

  if (is_loading) {
    return <PageLoader />;
  }

  if (is_error) {
    return <Error message={error} />;
  }

  return (
    <Main
      page={{
        name: shop?.name,
        icon: <ShopIcon />,
        breadcrumbs: [
          {
            name: "Shopy",
            path: "/shops",
          },
          { name: shop?.name },
        ],
        buttons: (
          <Button
            type="delete"
            text="Usuń sklep"
            onClick={() => setShowDeleteModal(true)}
          />
        ),
      }}
    >
      {show_delete_modal && (
        <ModalDelete
          handleDelete={handleDelete}
          handleClose={() => setShowDeleteModal(false)}
          name={`sklep ${shop?.name}?`}
        />
      )}
      {channel_to_delete?.id && (
        <ModalDelete
          handleDelete={handleDeleteChannel}
          handleClose={() => setChannelToDelete(null)}
          name={`kanał ${channel_to_delete?.identifier}?`}
        />
      )}
      {show_add_platform_modal && (
        <AddPlatform
          shop_id={shop?.id}
          platform_ids={platform_ids}
          refetch={refetch}
          handleClose={() => setShowAddShopModal(false)}
        />
      )}
      <div className="dashboard-wrapper-flex">
        <div className="column-half">
          <BasicData
            initialValues={{
              name: shop?.name,
              identifier: shop?.identifier,
              label_text: shop?.label_text,
              label_color: shop?.label_color,
            }}
            shop_id={id}
            refetch={refetch}
          />
        </div>
        <div className="column-half">
          <Dashboard
            header={{
              icon: "platform",
              title: "Platformy",
            }}
            footer={
              <Button
                type="add"
                text="Dodaj platformę"
                onClick={() => setShowAddShopModal(true)}
              />
            }
          >
            {shop?.channels?.length > 0 && (
              <table className="table">
                <thead className="table__header table-head">
                  <tr>
                    <th>Nazwa</th>
                    <th>Działania</th>
                  </tr>
                </thead>
                <tbody className="table__body table-body">
                  {shop.channels.map(({ id, identifier, platform }) => (
                    <tr key={id}>
                      <td>
                        <Label
                          text={platform?.label_text}
                          type="fill"
                          color={platform?.label_color}
                        />
                        {platform?.name} ({identifier})
                      </td>
                      <td>
                        <Button
                          type="delete-bin"
                          onClick={() =>
                            setChannelToDelete({
                              id,
                              identifier,
                            })
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Dashboard>
        </div>
      </div>
    </Main>
  );
};

export default ShopEdit;
